import RequestQueueManager from 'components/layout_and_quote_builder/utils/RequestQueueManager.js';

// A dedicated request queue (same concurrency limit as the default, MANUFACTURING_COST_CALCULATOR_MAX_CONCURRENT,
// falling back to 3) for fetching each manufacturing line's priced_solution_count AFTER the cards render.
//
// Kept separate from defaultRequestQueueManager on purpose: that queue drives the full-screen "Loading
// Layout Combinations" progress overlay (ProgressContext subscribes to it), and these are background
// per-card fetches -- the cards are already on screen, each showing its own small spinner, so they must
// not raise that overlay. A dedicated instance mirrors how SectionFetchQueue runs its own queue.
const pricedSolutionCountQueue = new RequestQueueManager(parseInt(window.RequestQueueManagerC));

export default pricedSolutionCountQueue;
